import clsx from 'clsx';
import React from 'react';
import { IconCheck, IconWarning } from '../../ui/v2';

/** Centred outcome screen for the POS OAuth callback routes. */
const IntegrationResult: React.FC<{
  tone: 'success' | 'warning' | 'danger';
  title: string;
  message: string;
  details?: React.ReactNode;
  note?: string;
  actions: React.ReactNode;
}> = ({ tone, title, message, details, note, actions }) => (
  <div className="av2 rounded-v2-lg border border-v2-line bg-v2-surface">
    <div className="mx-auto flex min-h-[60vh] max-w-[440px] flex-col items-center justify-center px-6 py-12 text-center">
      <div
        className={clsx(
          'mb-4 flex h-10 w-10 items-center justify-center rounded-v2 border',
          tone === 'success' && 'border-v2-success/30 text-v2-success',
          tone === 'warning' && 'border-v2-warning/30 text-v2-warning',
          tone === 'danger' && 'border-v2-danger/30 text-v2-danger',
        )}
      >
        {tone === 'success' ? (
          <IconCheck size={18} />
        ) : (
          <IconWarning size={18} />
        )}
      </div>
      <h1 className="text-v2-16 font-semibold text-v2-fg">{title}</h1>
      <p className="mt-1.5 text-v2-13 text-v2-fg-2">{message}</p>
      {details && (
        <dl className="mt-5 w-full rounded-v2 border border-v2-line px-3 text-left">
          {details}
        </dl>
      )}
      {note && <p className="mt-5 text-v2-12 text-v2-fg-3">{note}</p>}
      <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row">
        {actions}
      </div>
    </div>
  </div>
);

export default IntegrationResult;
